import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import AuthStore from "../../stores/AuthStore"
import { QuestionnaireDetailsStore } from "../../stores/QuestionnarieDetailsStore"
import { Text } from "../."
import { BorderButton } from "../buttons"
import { ScreenContainer } from "../other"
import { QuestionnaireHeader } from "./QuestionnaireHeader"
import { QuestionnaireUserBadge } from "./QuestionnaireUserBadge"

export const QuestionnaireUserConfig = observer(() => {
	const { t } = useTranslation()
	const { user } = AuthStore
	const navigate = useNavigate()

	const [store] = useState(() => new QuestionnaireDetailsStore())

	return (
		<ScreenContainer>
			<div className="flex min-h-full flex-col pb-[120px]">
				<QuestionnaireHeader to={"questionnaire"} />
				<div className="mt-[80px] flex-row items-center justify-center">
					<Text>{t("questionnaire.user_type")}</Text>
				</div>
				<div className="mt-[100px] flex-row items-center justify-around">
					<QuestionnaireUserBadge
						disabled={!store.isAnonimouslySelected}
						user={user ?? undefined}
						onClick={() => store.changeValue("username", user?.displayName ?? "")}
					/>
					<QuestionnaireUserBadge disabled={store.isAnonimouslySelected} onClick={() => store.changeValue("username", "anonimously")} />
				</div>
				<div className="absolute bottom-[45px] w-full">
					<BorderButton text={t("questionnaire.continue")} onClick={() => navigate("questionnaire/config")} />
				</div>
			</div>
		</ScreenContainer>
	)
})
